import { styled } from "@material-ui/core/styles";
import { FormLabel } from "@material-ui/core";

import theme from "../../constants/theme";

export default styled(FormLabel)({
  fontWeight: "bold",
  textTransform: "uppercase",
  display: "block",
  color: theme.palette.secondary.main,
  marginTop: theme.spacing(3),
});
